"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnsupportedError = exports.TimeoutError = exports.InvalidStateError = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _construct(Parent, args, Class) { if (isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * Error produced when calling a method in an invalid state.
 */
var InvalidStateError =
/*#__PURE__*/
function (_Error) {
  _inherits(InvalidStateError, _Error);

  function InvalidStateError(message) {
    var _this;

    _classCallCheck(this, InvalidStateError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InvalidStateError).call(this, message));
    _this.name = 'InvalidStateError';
    if (Error.hasOwnProperty('captureStackTrace')) // Just in V8.
      Error.captureStackTrace(_assertThisInitialized(_this), InvalidStateError);else _this.stack = new Error(message).stack;
    return _this;
  }

  return InvalidStateError;
}(_wrapNativeSuper(Error));
/**
 * Error produced when a Promise is rejected due to a timeout.
 */


exports.InvalidStateError = InvalidStateError;

var TimeoutError =
/*#__PURE__*/
function (_Error2) {
  _inherits(TimeoutError, _Error2);

  function TimeoutError(message) {
    var _this2;

    _classCallCheck(this, TimeoutError);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(TimeoutError).call(this, message));
    _this2.name = 'TimeoutError';
    if (Error.hasOwnProperty('captureStackTrace')) // Just in V8.
      Error.captureStackTrace(_assertThisInitialized(_this2), TimeoutError);else _this2.stack = new Error(message).stack;
    return _this2;
  }

  return TimeoutError;
}(_wrapNativeSuper(Error));
/**
 * Error indicating not support for something.
 */


exports.TimeoutError = TimeoutError;

var UnsupportedError =
/*#__PURE__*/
function (_Error3) {
  _inherits(UnsupportedError, _Error3);

  function UnsupportedError(message, data) {
    var _this3;

    _classCallCheck(this, UnsupportedError);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(UnsupportedError).call(this, message));
    _this3.name = 'UnsupportedError';
    if (Error.hasOwnProperty('captureStackTrace')) // Just in V8.
      Error.captureStackTrace(_assertThisInitialized(_this3), UnsupportedError);else _this3.stack = new Error(message).stack;
    _this3.data = data;
    return _this3;
  }

  return UnsupportedError;
}(_wrapNativeSuper(Error));

exports.UnsupportedError = UnsupportedError;


//////////////////
// WEBPACK FOOTER
// ./~/mediasoup-client/lib-es5/errors.js
// module id = 76
// module chunks = 0